import type { Action, ActionStatusType } from "../actions.types";
import { ACTION_STATUS } from "../actions.constants";

/**
 * Determines if an action's status should be updated to the new status.
 *
 * Rules:
 * - Never re-set the same status (no-op write)
 * - Never downgrade from "Completed"
 * - Always allow setting to "Completed" from non-completed states
 * - Always allow forward transitions from "Not Started" / "Action Issued"
 *
 * @param action - The action to check
 * @param newStatus - The desired new status
 * @returns true if the status should be updated, false otherwise
 */
export function shouldUpdateStatus(
  action: Action,
  newStatus: ActionStatusType
): boolean {
  const currentStatus = action.current_status?.name;

  // If no current status, allow any update
  if (!currentStatus) {
    return true;
  }

  // Never re-set to the same status
  if (currentStatus === newStatus) {
    return false;
  }

  // If already completed, block downgrades
  if (currentStatus === ACTION_STATUS.COMPLETED) {
    return false;
  }

  // From any other state, allow forward transitions (to "In Progress" or "Completed")
  return true;
}

